import { initPinpoint } from "./pinpointClient";
import { UpdateEndpointCommand } from "@aws-sdk/client-pinpoint";
import { config } from "JS/Config";
import { pinPointConstants } from "JS/Helpers/Constants";
import { captureSentryError } from "JS/Helpers/SentryHelper";

export type ChannelType = "GCM" | "APNS";

export const registerEndpoint = async (
    userId: string,
    deviceId: string,
    deviceToken: string,
    channelType: ChannelType,
    inAppPushStatus: boolean,
) => {
    const pinpoint = initPinpoint();
    const endpointId = `${userId}-${deviceId}`;

    const endpointData = {
        Address: deviceToken,
        ChannelType: channelType,
        OptOut: inAppPushStatus
            ? pinPointConstants.OptOutNone
            : pinPointConstants.OptOutAll,
        Demographic: {
            Platform: pinPointConstants.platform,
        },
        User: {
            UserId: userId,
        },
    };

    try {
        const response = await pinpoint.send(
            new UpdateEndpointCommand({
                ApplicationId: config.pinpointAppId || "",
                EndpointId: endpointId,
                EndpointRequest: endpointData,
            }),
        );
        localStorage.setItem("pinpointRegistered", "true");

        console.log("Pinpoint endpoint subscribed (web):", inAppPushStatus);
        return response;
    } catch (err) {
        captureSentryError(err, {
            location: "pinpointEndpointService - registerEndpoint",
        });
    }
};

export const optOutEndpoint = async (userId: string, deviceId: string) => {
    const pinpoint = initPinpoint();
    const endpointId = `${userId}-${deviceId}`;

    try {
        const response = await pinpoint.send(
            new UpdateEndpointCommand({
                ApplicationId: config.pinpointAppId || "",
                EndpointId: endpointId,
                EndpointRequest: {
                    OptOut: pinPointConstants.OptOutAll,
                },
            }),
        );

        console.log("Pinpoint endpoint unsubscribed");
        return response;
    } catch (err) {
        captureSentryError(err, {
            location: "pinpointEndpointService - optOutEndpoint",
        });
    }
};
